import React from 'react';
import ReactDOM from 'react-dom';
import './css/fonts.css';
import withReduxFeatures from './withReduxFeatures';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
const customHistory = createBrowserHistory();

const WrappedApp = withReduxFeatures(App);
document.title = 'ادمین فطام '
ReactDOM.render(
    <Router history={customHistory} >
        <WrappedApp />
    </Router>
    , document.getElementById('root'));
serviceWorker.register();
